import { EntitySelectorsFactory } from '@ngrx/data';
import { TipoAnalisisLaboratorio } from './tipos-analisis-laboratorio.model';

export const tiposAnalisisLaboratorioSelectors =
  new EntitySelectorsFactory().create<TipoAnalisisLaboratorio>(
    'TipoAnalisisLaboratorio'
  );

export const selectAllTiposAnalisisLaboratorio =
  tiposAnalisisLaboratorioSelectors.selectEntities;
